import React from 'react'
import Header from '../../layout/Header'
import Footer from '../../layout/Footer'
import HomeDetailsMain from './HomeDetailsMain'

function HomeDetails() {
    return (
        <div className='HomeDetails'>
            <Header />
            <HomeDetailsMain />
            <Footer />
        </div>
    )
}

export default HomeDetails
